import React from "react";

const css = `
.b {
  fill: #b1b4b3;
}
.c {
  fill: #e8edeb;
}
.d {
  fill: #939997;
}
/* Hover effect for zones */
#zone-1:hover, #zone-2:hover, #zone-3:hover, #zone-4:hover, #zone-5:hover,
#zone-6:hover, #zone-7:hover, #zone-8:hover, #zone-9:hover, #zone-10:hover,
#zone-11:hover, #zone-12:hover, #zone-13:hover, #zone-14:hover, #zone-15:hover,
#zone-16:hover, #zone-17:hover, #zone-18:hover {
  fill: #02a693;
  opacity: 1;
  cursor: pointer;
}
`;

const RoyalsTeamStoreSvg = ({ children }) => {
  return (
    <svg id="a" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 962.24646 581.778992">
      <defs>
        <style>{css}</style>
      </defs>
      <path class="c" d="M900.171326,202.416382l20.043823-118.289673c-38.923118-17.286727-292.392944-66.126709-375-66l-3.094971,44.78595-143.368286-9.907959,1.69397-42.917603C327.881381,4.157756,82.799522,18.546814,10.517334,39.169373l29.697815,148.957336c57.988586-14.711853,157.391174-28.340881,189-30l52.631897,266.772705s-93.071289,10.316284-178.631897,27.227295l21.416321,119.092285c253.508633-44.144645,472.035094-48.149675,730.583679-26.092285l16.530273-133.557312,37.469727,6.557312,42.395569-205.076172-51.439392-10.634155Z"/>      <g>
        {children}
      </g>
      <circle class="d" cx="478.71521" cy="290.64626" r="52.758237"/>
      <path class="d" d="M355.718781,8.999939c16.817223,0,31.969254.348175,44.727089,1.087189l-1.694,42.917572,143.368279,9.90799,3.095001-44.78598c90.994995.148712,338.335693,50.40741,375,66l-20.043823,118.289703,51.439392,10.634155-42.395569,205.076134-37.469727-6.557281-16.530273,133.557281c-96.258057-8.822113-191.076477-13.166462-282.997467-13.166462-160.896446,0-312.844397,13.320805-447.586243,39.258747l-21.41629-119.092283c85.560577-16.911001,178.631862-27.227285,178.631862-27.227285l-52.631858-266.772709c-31.60886,1.659149-131.011433,15.288147-189.000004,30L10.517303,39.169403C79.172089,22.614349,250.456543,8.999939,355.718781,8.999939M355.718727,0C253.446297,0,79.454437,13.288269,8.407593,30.420135l-8.407593,2.027435,1.69101,8.481567,29.697845,148.957275,1.853012,9.294586,9.186432-2.330719c53.920166-13.679688,142.217751-26.162842,179.492111-29.200623l49.212193,249.439617c-26.164795,3.134125-100.727009,12.583138-169.662586,26.208286l-8.678574,1.715282,1.565857,8.706717,21.416275,119.092283,1.612442,8.967148,8.946701-1.72229c134.765293-25.942429,284.782722-39.096428,445.884995-39.096428,92.185577,0,187.123291,4.417145,282.176025,13.12886l8.682251.795715,1.071045-8.652718,15.36792-124.166241,28.148743,4.926098,8.598022,1.504715,1.767029-8.548,42.395569-205.076145,1.822144-8.813568-8.813721-1.821991-42.9375-8.876526,18.593506-109.730194,1.186951-7.005157-6.538269-2.780548c-18.919556-8.046143-89.992432-24.597717-168.995544-39.356293-43.871429-8.195587-152.109314-27.267731-209.512024-27.361572l-8.413269-.013733-.580002,8.393311-2.474518,35.807343-125.672577-8.685059,1.349373-34.186432.348434-8.82901-8.821007-.510986c-12.626137-.731293-27.849571-1.102142-45.247566-1.102142h0Z"/>
      <g>
        <rect x="460.710409" y="21.30117" width="15.000325" height="63.971758" transform="translate(381.989019 516.565035) rotate(-85.95009)"/>
        <rect x="368.114226" y="532.89229" width="253.086733" height="14.999965" transform="translate(-14.865768 13.993291) rotate(-1.596733)"/>
        <rect x="735.155323" y="513.932051" width="14.999657" height="54.864779" transform="translate(160.921398 1252.840352) rotate(-86.819548)"/>
      </g>
    </svg>
  );
};

export default RoyalsTeamStoreSvg;